/* eslint-disable */
const TOKEN_KEYS = {
  accessToken: "access_token",
  refreshToken: "refresh_token",
  tokenExp: "tokenExp",
  idToken: "idToken",
  tokenTime: "tockentime",
};

function readAuthData() {
  return {
    token: localStorage.getItem(TOKEN_KEYS.accessToken),
    refreshToken: localStorage.getItem(TOKEN_KEYS.refreshToken),
    tokenExp: localStorage.getItem(TOKEN_KEYS.tokenExp),
    idToken: localStorage.getItem(TOKEN_KEYS.idToken),
    timenow: localStorage.getItem(TOKEN_KEYS.tokenTime),
  };
}

function emptyAuthData() {
  return {
    token: null,
    refreshToken: null,
    tokenExp: null,
    idToken: null,
    timenow: null,
  };
}

const state = () => ({
  authData: readAuthData(),
});

const getters = {
  authenticated(state: { authData: { token: string | null } }) {
    return Boolean(state.authData.token);
  },
  getAccessToken(state: { authData: { token: string | null } }) {
    return state.authData.token;
  },
  getRefreshToken(state: { authData: { refreshToken: string | null } }) {
    return state.authData.refreshToken;
  },
  getIdToken(state: { authData: { idToken: string | null } }) {
    return state.authData.idToken;
  },
  getAuthData(state: { authData: any }) {
    return state.authData;
  },
  isTokenActive(state: { authData: { tokenExp: string | null; timenow: string | null } }) {
    const tokenExp = Number(state.authData.tokenExp);
    const tokenIssuedAt = Number(state.authData.timenow);

    if (!tokenExp || !tokenIssuedAt) {
      return false;
    }

    return tokenExp * 1000 - (Date.now() - tokenIssuedAt) > 0;
  },
};

const actions = {
  loginuser({ commit }: any, data: any) {
    commit("setUser", data);
  },
  logoutuser({ commit }: any) {
    commit("clearUser");
  },
};

const mutations = {
  setUser(state: { authData: any }, userData: any) {
    const issuedAt = Date.now().toString();
    const tokenExp = userData.expiresIn || 3600;

    state.authData = {
      token: userData.accessToken,
      refreshToken: userData.refreshToken || null,
      tokenExp,
      idToken: userData.idToken,
      timenow: issuedAt,
    };

    localStorage.setItem(TOKEN_KEYS.accessToken, userData.accessToken);
    localStorage.setItem(TOKEN_KEYS.tokenExp, String(tokenExp));
    localStorage.setItem(TOKEN_KEYS.idToken, userData.idToken);
    localStorage.setItem(TOKEN_KEYS.tokenTime, issuedAt);

    if (userData.refreshToken) {
      localStorage.setItem(TOKEN_KEYS.refreshToken, userData.refreshToken);
    } else {
      localStorage.removeItem(TOKEN_KEYS.refreshToken);
    }
  },
  clearUser(state: { authData: any }) {
    state.authData = emptyAuthData();
    Object.values(TOKEN_KEYS).forEach((key) => localStorage.removeItem(key));
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
